<template>
  <footer
    v-if='kirby'
    class='bottom'>
    <div
      v-if='kirby.site'
      class='contact'
      v-html='frommarkdown(kirby.site.footercontact)' />
    <div
      v-if='kirby.site'
      class='copyright'
      v-html='frommarkdown(kirby.site.footercopyright)' />
  </footer>
</template>

<script>
module.exports = {
  computed: {
    kirby () {
      if(this.$store) return this.$store.state.kirby
    }
  },
  methods: {
    frommarkdown(input) {
      if(input) return this.$root.markdown(input);
    }
  }
}
</script>

<style>

  footer.bottom {
    padding-top: 7rem;
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  footer.bottom .contact p {
    font-size: 2rem;
    margin-bottom: 1em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  footer.bottom .copyright {
    font-size: 1rem;
    line-height: 1.58rem;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  @media only screen and (max-aspect-ratio: 4/5) and (max-width: 700px) {
    footer.bottom .copyright {
      position: relative;
      padding-bottom: 3rem;
    }
  }

</style>
